const { CrudModel } = require('./crud');

export class ProfessionModel extends CrudModel {
	constructor() {
		super('admin/profession', []);
	}
}

export default new ProfessionModel();
